<template>
  <Teleport to="body">
    <div
      id="pageLoader"
      class="page-loader"
    >
      <i
        class="fa-solid fa-spinner-scale fa-spin-pulse page-loader-icon"
      />
    </div>
  </Teleport>
</template>
<style scoped>

</style>